import { CountDown, OTPInput } from 'components'
import { sendVerificationCode, submitVerificationCode } from 'services/courier_signup'

export default () => {
  const store = Alpine.store('CourierSignup')

  Alpine.data('CountDown', CountDown)
  Alpine.data('OTPInput', OTPInput)

  return {
    verificationCode: '',
    inputs: null,
    verificationCodeInputCompleted: false,
    isSubmitting: false,
    tries: 0,
    submit () {
      this.isSubmitting = true
      this.spinner.toggle()

      submitVerificationCode({
        phone: store.phoneNumber.substring(1),
        verificationCode: this.verificationCode,
        language: store.localeCode,
        tries: this.tries
      }, (data) => {
        this.errors = ''
        this.isSubmitting = false
        this.spinner.toggle()

        if (data.success) {
          localStorage.setItem('user_country', data.country)
          if (data.extra_details.update_request_fields.length) {
            store.setActiveFormStep(data.extra_details.update_request_fields)
          } else {
            store.setActiveFormStep(0)
          }
          store.setActiveStage('signup-form')
          this.tries = 0
        }
      }, (data) => {
        this.tries++
        this.errors = data.errors
        this.isSubmitting = false
        this.spinner.toggle()
        if (data.errors.includes('already signed up')) {
          store.setActiveStage('account-exist')
        }
      })
    },

    resendSignupCode () {
      this.isSubmitting = true
      sendVerificationCode({
        phone: store.phoneNumber.substring(1),
        language: 'en'
      }, () => {
        this.errors = ''
        this.init()
      }, (data) => {
        this.errors = data.errors
      })
      this.isSubmitting = false
    }
  }
}

